module.exports = __webpack_public_path__ + "static/media/gansu_icon_small.4c419eca.png";